import {Component, Input, OnChanges, inject} from '@angular/core';
import {LineChartSettingsService} from '../line-chart.settings.service';
import {FeatureFlagService} from '../../../services/feature-flag.service';
import {first} from 'rxjs';

@Component({
  selector: 'app-chart-card',
  templateUrl: './chart-card.component.html',
  styleUrls: ['./chart-card.component.scss'],
  providers: [LineChartSettingsService],
  standalone: true,
  imports: [],
})
export class ChartCardComponent implements OnChanges {
  private featureFlagService = inject(FeatureFlagService);

  // Feature flag was causing chart to init properly
  // When used inside the chart container component
  // Due to the timing of content projection
  @Input() featureFlag: string;

  chartEnabled = true;

  ngOnChanges() {
    this.featureFlagService
      .get(this.featureFlag)
      .pipe(first())
      .subscribe((flagVariant) => {
        if (this.featureFlag) this.chartEnabled = flagVariant === 'on';
      });
  }
}
